import { createContext } from 'react';

/**
 * Values the Partner Management route shell publishes to its sub-tabs.
 */
export interface SupplierTabContextValue {
  isSupplierLoggedIn?: boolean | undefined;
  isProductionLocationTier: boolean;
  supplierId?: string | undefined;
}

const SupplierTabContext = createContext<SupplierTabContextValue | null>(null);

export default SupplierTabContext;
